import { createApp } from "vue";
import App from "./App.vue";
import PrimeVue from "primevue/config";

import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import 'primeflex/primeflex.css';


import "@/styles/global.scss";

import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Dropdown from "primevue/dropdown";

const app = createApp(App);

app.use(PrimeVue);

app.component("YButton", Button);
app.component("YInputText", InputText);
app.component("YPassword", Password);
app.component("YDropdown", Dropdown);

app.mount("#app");
